import React, { useState, useRef, useEffect } from 'react';
import './styles.scss';
import { Popover } from 'antd';
import { MyButton } from 'components/Atoms';
import Icon, { MoreHorizontalIcon } from 'components/Atoms/Icon';

const ActionButton = (props) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const popoverRef = useRef(null);

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const closeTimeoutRef = useRef();

  const handleMouseEnter = () => {
    if (!isSafari) return;
    clearTimeout(closeTimeoutRef.current);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    if (!isSafari) return;
    closeTimeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 200);
  };

  return (
    <Popover
      {...props}
      trigger={isSafari ? 'click' : props.trigger}
      visible={isSafari ? open : undefined}
      content={
        <div
          ref={popoverRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {props.content}
        </div>
      }
    >
      <MyButton
        ref={buttonRef}
        className="my-btn-no-style rotate-90 icon-action"
        onClick={() => {
          if (isSafari) {
            const event = new CustomEvent('safari-menu-open', {
              detail: buttonRef.current,
            });
            window.dispatchEvent(event);

            setOpen((prev) => !prev);
          }
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Icon component={MoreHorizontalIcon} />
      </MyButton>
    </Popover>
  );
};

ActionButton.defaultProps = {
  placement: 'bottomRight',
  overlayClassName: 'popup-action-button',
  align: { offset: [-10, -10] },
};

export default ActionButton;
